export default __webpack_public_path__ + "static/badge-dont-2-bold-light-903f6e7fca3e2633883154b1481795a45cbeb3f21db0e38dc5d80307e8f6bc0d.png";